const dom = require('../utils/DOM');

function MagazinePage() {
	if (dom.$body.hasClass('archive') || dom.$body.hasClass('single-issue')) {
		this.init();
	}
}

MagazinePage.prototype = {
	init: function() {
		// this.$magazineIssuesList = $('.magazine-issues-list');
		this.$magIssuesArchiveBtn = $('.mobile-archive-opener-js');
		this.$archiveSection = $('.archive-list-js');
		this.$archiveSectionBtn = $('.mobile-archive-closer-js');

		this.$magazineInfo = $('.magazine-single-js');
		this.$mobileMenu = $('.mobile-menu-toggle-block');

		if (this.$archiveSection.length > 0) {
			this.$magIssuesArchiveBtn.click(() => {
				this.openArchive();
			});
			this.$archiveSectionBtn.click(() => {
				this.closeArchive();
			});
		} else {
			this.$magIssuesArchiveBtn.hide();
		}

		dom.$window.on('resize orientationchange', () => {
			if (dom.$window.width() > 767) {
				this.$archiveSection.fadeIn();
				this.$magazineInfo.removeClass('hide-block');
				this.$mobileMenu.removeClass('hide-block');
			} else {
				this.closeArchive();
			}
		});
	},
	openArchive: function() {
		this.$archiveSection.fadeIn();
		this.$magazineInfo.addClass('hide-block');
		this.$mobileMenu.addClass('hide-block');
	},
	closeArchive: function() {
		this.$archiveSection.hide();
		this.$magazineInfo.removeClass('hide-block');
		this.$mobileMenu.removeClass('hide-block');
	},
};

module.exports = new MagazinePage();
